import { render, staticRenderFns } from "./ModelHouseTasks.vue?vue&type=template&id=0c6cafc9&"
import script from "./ModelHouseTasks.vue?vue&type=script&lang=js&"
export * from "./ModelHouseTasks.vue?vue&type=script&lang=js&"
import style0 from "./ModelHouseTasks.vue?vue&type=style&index=0&id=0c6cafc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports